"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationEditor = void 0;
const tslib_1 = require("tslib");
const css_1 = require("@emotion/css");
const react_1 = tslib_1.__importDefault(require("react"));
const dnd_1 = require("@hello-pangea/dnd");
const ui_1 = require("@grafana/ui");
const OperationEditorBody_1 = require("./OperationEditorBody");
function OperationEditor({ operation, index, onRemove, onToggle, onChange, onRunQuery, queryModeller, query, datasource, flash, highlight, timeRange, isConflictingOperation, }) {
    const def = queryModeller.getOperationDefinition(operation.id);
    const theme = (0, ui_1.useTheme2)();
    const isConflicting = isConflictingOperation ? isConflictingOperation(operation, query.operations) : false;
    const styles = getStyles(theme, isConflicting);
    if (!def) {
        return react_1.default.createElement("span", null,
            "Operation ",
            operation.id,
            " not found");
    }
    const isInvalid = (isDragging) => {
        if (isDragging) {
            return undefined;
        }
        return isConflicting ? true : undefined;
    };
    return (react_1.default.createElement(dnd_1.Draggable, { draggableId: `operation-${index}`, index: index }, (provided, snapshot) => (react_1.default.createElement(ui_1.InlineField, { error: 'You have conflicting label filters', invalid: isInvalid(snapshot.isDragging), className: (0, css_1.cx)(styles.error, styles.cardWrapper) },
        react_1.default.createElement(OperationEditorBody_1.OperationEditorBody, { provided: provided, flash: flash, highlight: highlight, isConflicting: isConflicting, index: index, operation: operation, definition: def, onChange: onChange, onRemove: onRemove, onToggle: onToggle, queryModeller: queryModeller, query: query, timeRange: timeRange, onRunQuery: onRunQuery, datasource: datasource })))));
}
exports.OperationEditor = OperationEditor;
const getStyles = (theme, isConflicting) => {
    return {
        cardWrapper: (0, css_1.css)({
            alignItems: 'stretch',
        }),
        error: (0, css_1.css)({
            marginBottom: theme.spacing(1),
        }),
    };
};
//# sourceMappingURL=OperationEditor.js.map